import { Component, computed, input, InputSignal } from '@angular/core';
import { ApplicationErrorComponent } from '../../../components/application-error/application-error.component';

@Component({
  selector: 'td-wb-w8ben-form-error',
  templateUrl: 'w8ben-form-error.component.html',
  imports: [ApplicationErrorComponent]
})
export class W8BenFormErrorComponent {
  readonly submitError: InputSignal<boolean> = input<boolean>(false);

  readonly title = computed(() => this.submitError()
    ? 'tdWb.w8BenForm.modal.error.DESCRIPTION_SUBMIT'
    : 'tdWb.w8BenForm.modal.error.DESCRIPTION');
}

